/**
  Autogenerated file. Do not edit manually.
  @openapi https://search-bff.envdevel.com/v3/api-docs
*/


export type Kind = typeof Kind[keyof typeof Kind];


export const Kind = {
  PARAGRAPH: 'PARAGRAPH',
  LIST: 'LIST',
} as const;
